import App from '../../components/App';
import props from '../../configs/propsCool';

export default function FontGenerator() {
  return <App {...props} />;
}
